import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import './Button.scss';
import { getImage, photos } from '../../utils/common';
function Button(props) {
    const showPrice = () => {
        return !!props.actualPrice || !!(props === null || props === void 0 ? void 0 : props.averagePrice);
    };
    return <>
      {showPrice() && <View className="comprehensive-card-button-container">
          <Image className="comprehensive-card-button-bg" source={getImage(photos.button_bg)}/>
          <View className="comprehensive-card-button-text-container">
            <Text className="comprehensive-card-button-RMB">¥</Text>
            <Text className="comprehensive-card-button-actual-price">
              {props.actualPrice || (props === null || props === void 0 ? void 0 : props.averagePrice)}
            </Text>
            <Text x-if={!(props === null || props === void 0 ? void 0 : props.averagePrice)} className="comprehensive-card-button-char-qi">
              起
            </Text>
            {props.originalPrice && props.actualPrice !== props.originalPrice && <Text className="comprehensive-card-button-original-price">
                ¥{props.originalPrice}
              </Text>}
            {props.reducedPrice && <View className="comprehensive-card-button-reduced-price-container">
                <Text className="comprehensive-card-button-reduced-price">
                  {props.reducedPrice}
                </Text>
              </View>}
            <Text className="comprehensive-card-button-buy">{props.buyText}</Text>
          </View>
        </View>}
    </>;
}
export default memo(Button);
